import { FC } from 'react';

interface Props {
    text: string;
    className?: string;
}

export const SplitChar: FC<Props> = (props) => {
    const { text, className } = props;

    return (
        <div className={className}>
            {text.split('').map((char, i) => (
                <span key={`${char}-${i}`}>{char}</span>
            ))}
        </div>
    );
};
